// test536
(536 && 0);
